import { ChainBadgeFragment, CurrencyLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionCurrencyPreviewFragment } from "../CollectionCurrencyPreview/CollectionCurrencyPreview.fragment"
import { CurrencyMetadataChipsFragment } from "../CurrencyMetadataChips/CurrencyMetadataChips.fragment"
import { CurrencyHeaderWatchlistButtonFragment } from "../CurrencyWatchlistButton"
import { CurrencyLinksFragment } from "./CurrencyLinks.fragment"

export const CurrencyInfoFragment = graphql(
  `
    fragment CurrencyInfo on Currency {
      usdPrice
      stats {
        oneDay {
          priceChange
        }
      }
      chain {
        ...ChainBadge
      }
      ...CurrencyMetadataChips
      ...CurrencyLinks
      ...CollectionCurrencyPreview
      ...CurrencyLockup
      ...CurrencyHeaderWatchlistButton
    }
  `,
  [
    ChainBadgeFragment,
    CurrencyLinksFragment,
    CurrencyMetadataChipsFragment,
    CollectionCurrencyPreviewFragment,
    CurrencyLockupFragment,
    CurrencyHeaderWatchlistButtonFragment,
  ],
)
